import { ACE_BLOCKCHAINS } from '@services/static-data/blockchains'
import { defineChain } from 'thirdweb/chains'

import type { Chain } from 'thirdweb/chains'

/**
 * List of supported chains.
 */
export const SUPPORTED_CHAINS = ACE_BLOCKCHAINS.reduce<Chain[]>((acc, b) => {
  if (b.chainId != null) {
    acc.push(defineChain(b.chainId))
  }

  if (b.testnetChainId != null) {
    acc.push(defineChain(b.testnetChainId))
  }

  return acc
}, [])

/**
 * Map of supported chain IDs to Chain objects.
 */
export const CHAIN_IDS_TO_CHAINS = SUPPORTED_CHAINS.reduce<
  Record<number, Chain>
>((acc, c) => {
  acc[c.id] = c
  return acc
}, {})

export type SupportedChainId = keyof typeof CHAIN_IDS_TO_CHAINS

export const SUPPORTED_CHAIN_IDS = SUPPORTED_CHAINS.map((c) => c.id)
